import type { ReactNode } from 'react';
import { useMemo } from 'react';
import { useEquipmentByIdsQuery } from '@/feature/equipment/queries';
import FleetContext from './detailsContext';

interface FleetContextProviderProps {
  children?: ReactNode;
  selected: string[];
}

const DetailsContextProvider = ({
  children,
  selected,
}: FleetContextProviderProps) => {
  const {
    data = [],
    status,
    isLoading,
  } = useEquipmentByIdsQuery({
    equipmentIds: selected,
    include: [
      'documents',
      'inspection_interval',
      'trip_meter',
      'presentations',
      'owner',
    ],
  });

  const selectedEquipment = useMemo(
    () =>
      [...data].sort(
        (a, b) => selected.indexOf(a.id) - selected.indexOf(b.id)
      ) ?? [],
    [data, selected]
  );

  return (
    <FleetContext.Provider
      value={{
        selectedEquipment,
        isLoading,
        status: status || 'success',
      }}
    >
      {children}
    </FleetContext.Provider>
  );
};

export default DetailsContextProvider;
